import { computed } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store.js';
import { useAccount } from 'dashboard/composables/useAccount';
import { useConfig } from 'dashboard/composables/useConfig';
import { useCamelCase } from 'dashboard/composables/useTransformKeys';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export function useAidexacx() {
  const store = useStore();
  const { isCloudFeatureEnabled, currentAccount } = useAccount();
  const { isEnterprise } = useConfig();
  const uiFlags = useMapGetter('accounts/getUIFlags');

  const aidexacxEnabled = computed(() => {
    return isCloudFeatureEnabled(FEATURE_FLAGS.AIDEXACX);
  });

  const aidexacxLimits = computed(() => {
    return currentAccount.value?.limits?.aidexacx;
  });

  const documentLimits = computed(() => {
    if (aidexacxLimits.value?.documents) {
      return useCamelCase(aidexacxLimits.value.documents);
    }

    return null;
  });

  const responseLimits = computed(() => {
    if (aidexacxLimits.value?.responses) {
      return useCamelCase(aidexacxLimits.value.responses);
    }

    return null;
  });

  const isFetchingLimits = computed(() => uiFlags.value.isFetchingLimits);

  const fetchLimits = () => {
    if (isEnterprise) {
      store.dispatch('accounts/limits');
    }
  };

  return {
    aidexacxEnabled,
    aidexacxLimits,
    documentLimits,
    responseLimits,
    fetchLimits,
    isFetchingLimits,
  };
}
